import styles from './CTABanner.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class CTABanner extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get theme(): string {
        return this.dataset.theme ?? 'light';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(`cta-banner`, `theme-${this.theme}`);
        container.innerHTML = `
            <div class="base-grid">
                <div class="title"></div>
                <div class="content">
                    <div class="text-content"></div>
                    <div class="cta">
                        <slot name="cta"></slot>
                    </div>
                </div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(container.querySelector('.title'), 'title');
        this.cloneDefaultSlotContentIntoContainer(container.querySelector('.text-content'));
        // Remove CTA if not set
        if (!this.querySelector('[slot=cta]')) {
            container.querySelector('.cta').remove();
        }
        return container;
    }

}

customElements.define('nxt-cta-banner-section', CTABanner);
